/* eslint react-hooks/exhaustive-deps: 0 */
import { Select, Spin } from "antd";
import { debounce } from "lodash-es";
import styled from "styled-components";
import { useCallback, useMemo, useRef, useState } from "react";

import { request } from "common/components/request";

export function ServerSidePicker({ fetchOptions, value = [], ...props }) {
    const [fetching, setFetching] = useState(false);
    const [options, setOptions] = useState([]);
    const fetchRef = useRef(0);
    const debounceFetcher = useMemo(() => debounce((search) => {
        fetchRef.current += 1;
        const fetchId = fetchRef.current;
        setOptions([]);
        setFetching(true);
        fetchOptions(search).then((newOptions) => {
            if (fetchId !== fetchRef.current) {
                // for fetch callback order
                return;
            }
            setOptions(newOptions);
            setFetching(false);
        });
    }, 800), [fetchOptions]);
    
    return (
        <StyledSelect
            labelInValue
            value={value}
            filterOption={false}
            onSearch={debounceFetcher}
            notFoundContent={fetching ? <Spin size="small" /> : null}
            {...props}
            options={options}
        />
    );
}

ServerSidePicker.defaultProps = {
    showSearch: true
};

export function TypeAheadPicker({
    options,
    onChange,
    value
}) {
    const searchByName = useCallback(async(search) => request(options.url_by_name.replace("{search}", search))
        .then(({ results }) => results.map((result) => ({
            value: result[options.value],
            label: result[options.label]
        }))), []);
    
    const searchByREF = useCallback(async(search) => request(options.url_by_ref.replace("{search}", search))
        .then((result) => [{
            value: result[options.value],
            label: result[options.label]
        }])
        .catch((error) => []), []);
    
    const search = async(searchQuery) => {
        const mongo_ref_pattern = /^[\d,a-f]{24}$/;
        if (mongo_ref_pattern.test(searchQuery)) {
            return searchByREF(searchQuery);
        }
        return searchByName(searchQuery);
    };
    
    const translateRef = useCallback(async(id) => request(options.url_by_ref.replace("{search}", id))
        .then((result) => ({
            value: result[options.value],
            label: result[options.label]
        })), []);
    
    return (
        <ServerSidePicker
            value={value}
            translateRef={translateRef}
            fetchOptions={search}
            placeholder="Search"
            mode={options.mode}
            onChange={({ value: newValue }) => onChange(newValue)}
        />
    );
}

const StyledSelect = styled(Select)`
    width: 100%;
`;
